<script>
  if (window.self !== window.top) {
    let divWhite = document.createElement("div");
    divWhite.innerHTML = "";
    document.body.appendChild(divWhite);
  }
</script>
<router-outlet></router-outlet>
